
<div class="rotationSubscription" mb5 xs12 sm12>
  <b-col cols="12" sm="12" md="12" lg="12">
    <b-row mb5>
      <h3>{{ rotation.name }}</h3>
    </b-row>
    <b-row>
      <div class="w-100">
        <b-alert
          :show="dismissCountDown"
          dismissible
          fade
          variant="success"
          @dismiss-count-down="countDownChanged"
        >
          Rotation product has been saved!
        </b-alert>

        <keep-alive>
          <RotatingSubscriptionSkipSlots
            :subscription="subscription"
            :skip-delivery="skipDelivery"
            @selectSlot="selectSlot"
            @view-meals-selection-for-slot="
              (viewSub) => $emit('view-meals-selection-for-slot', viewSub)
            "
          />
        </keep-alive>
      </div>
    </b-row>
  </b-col>

  <rotating-subscription-order-modal
    v-if="selectProductModalFlag"
    v-model="rotation"
    :subscription-object="subscription"
    :vendor_uuid="vendor.uuid"
    :selected-date-time="selectedDateTime"
    @hidden="selectProductModalFlag = false"
  />
  <b-col cols="10" offset="1">
    <hr>
  </b-col>
</div>
